<template>
  <div class="left">
    <div v-for="(item, key) in list" :key="key">
      <template v-if="item.prescriptionPushStatus == 9">
        <div class="content">
          <div class="title left"></div>
          <div>
            <div class="box-content">
              <span>
                处方药{{ item.drugName }}未凭处方销售，进销存销售订单号为：{{ item.orderId }}
                <br />
                请注意凭处方销售处方药品
                <el-button type="text" @click="handleNavigatePer(item)">（查看详情）</el-button>
              </span>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="content">
          <div class="title left"></div>
          <div>
            <div class="box-content">
              <span>
                处方药{{ item.drugName }}待上传处方，进销存销售订单号为：{{ item.orderId }}

                <br />
                请及时上传处方
                <el-button type="text" @click="handleNavigatePer(item)">（查看详情）</el-button>
              </span>
            </div>
          </div>
        </div>
      </template>
      <!-- <div class="head">{{item.prescriptionPushStatus == 9 ? '':''}}提醒</div> -->
    </div>

    <!-- <div class="bottom left">请及时跟进处理。</div> -->
  </div>
</template>

<script>
export default {
  props: ['list'],
  filters: {
    patientSex(val) {
      return { 1: '男', 0: '女' }[val] || val;
    }
  },
  methods: {
    handleNavigatePer(item) {
      // register
      this.$emit('handleNavigatePer', item);
    }
  }
};
</script>
<style lang="scss" scoped>
.head {
  font-size: 14px;
  margin-bottom: 24px;
}
.title {
  font-size: 14px;
  font-weight: bold;
}
.content {
  color: #333;
  font-size: 14px;
  line-height: 28px;
  margin-bottom: 12px;
  // text-align: left;
}
.box-content {
  display: flex;
  max-width: 390px;
}
.box-item {
  min-width: 70px;
}
.num {
  font-weight: 600;
}
.color1 {
  color: #262626;
}
.color2 {
  color: #1e8dff;
}
.color3 {
  color: #ff4e47;
}
.left {
  text-align: left;
  margin-top: 20px;
}
.color4 {
  color: #ff8200;
}
</style>
